import { getVisitorSession, lastActivitySetter, } from './embed/store/session/visitor';
import sharedConfig from './shared_config';
export default {
    sessionGetter: getVisitorSession,
    lastActivitySetter: lastActivitySetter,
    tracking: {
        urls: ({ videoId }) => ({
            engagement: `/api/videos/${videoId}/engagements`,
            views: `/api/videos/${videoId}/views`,
            picked_video: `/api/videos/${videoId}/picked_videos`,
            thumbnailImpressions: '/api/thumbnail_impressions',
            ctaImpressions: '/api/cta_impressions',
            scrollVideos: '/api/videos/scroll_videos',
            scrollEndVideos: '/api/videos/scroll_end_videos',
            // sessionAssociations: '/api/session_associations'
        }),
        pixelUrls: () => (Object.assign(Object.assign({}, sharedConfig.tracking.pixelUrls), { sessionExperimentBucketAssignment: '/trk/session:experiment_bucket_assignment', sessionStartSession: '/trk/session:start_session', systemClickNotificationExternal: '/trk/system:click_notification_external', onboardingViewDisclosure: '/trk/onboarding:view_disclosure', onboardingClickConsent: '/trk/onboarding:click_consent' })),
    },
};
